export default __webpack_public_path__ + "d52eafad88688457aeda5d32da067758.png";